module.exports = __webpack_public_path__ + "static/media/icon-cross-grey.9d9b16b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-cross-grey.svg
// module id = 266
// module chunks = 3